import { render, staticRenderFns } from "./advance-request.vue?vue&type=template&id=23dafce8&scoped=true"
import script from "./advance-request.vue?vue&type=script&lang=js"
export * from "./advance-request.vue?vue&type=script&lang=js"
import style0 from "./advance-request.vue?vue&type=style&index=0&id=23dafce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dafce8",
  null
  
)

export default component.exports